<template>

    <div v-if="!fetcher.loading">

            <div class="alert alert-warning mb-6" role="alert" v-if="locked">
              Abonnemangets inställningar kan inte längre redigeras, eftersom priser börjat läggas in.
            </div>

            <div class="row">
                <div class="col-md-12">

                    <h3>Inställningar</h3>

                    <div class="custom-form-section">

                        <input-text
                            name="name"
                            label="Arbetsnamn"
                            v-model="subscription.name"
                            customErrorMessage="Ange ett arbetsnamn"
                        />

                        <input-text
                            name="name_public"
                            label="Namn för kunder"
                            v-model="subscription.name_public"
                            customErrorMessage="Ange ett namn"
                        />

                        <div class="custom-form-group">
                            <label class="form-label">Anteckningar</label>
                            <textarea class="form-control"></textarea>
                        </div>

                        <input-check-radio
                            type="radio"
                            name="duration_id"
                            v-model="subscription.duration_id"
                            label="Behandlingslängd"
                            :options="[
                                {value: 1, label: '25 minuter', disabled: locked},
                                {value: 2, label: '40 minuter', disabled: locked || disable40minutes},
                                {value: 4, label: '50 minuter', disabled: locked || disable50minutes},
                            ]"
                            customErrorMessage="Välj behandlingslängd"
                        />

                        <div class="custom-form-group">
                            <label class="form-label">Var erbjuds massage?</label>
                            <div class="form-check">
                              <input class="form-check-input"
                                     :class="{'is-invalid': getError('internal')}"
                                     @change="() => {
                                         clearError('internal')
                                         clearError('external')
                                     }"
                                     type="checkbox" value=""
                                     id="treatment-clinics"
                                     :disabled="locked"
                                     v-model="subscription.internal"
                              >
                              <label class="form-check-label" for="treatment-clinics">
                                På mottagningar
                              </label>
                            </div>

                            <div class="form-check">
                              <input class="form-check-input"
                                     :class="{'is-invalid': getError('external')}"
                                     @change="() => {
                                         clearError('internal')
                                         clearError('external')
                                     }"
                                     type="checkbox"
                                     value=""
                                     id="treatment-on-location"
                                     :disabled="locked || subscription.type === 'unlimited'"
                                     v-model="subscription.external"
                              >
                              <label class="form-check-label" for="treatment-on-location">
                                På arbetsplatsen
                              </label>
                            </div>
                        </div>

                    </div>

                </div>

                <div class="col-md-12">

                    <h3>Abonnemangsform</h3>

                    <div class="custom-form-group">

                        <div class="form-option-section" :class="{ 'inactive' : subscription.type !== 'binding_period'}">
                            <div class="form-check mb-0">
                              <input class="form-check-input" type="radio" name="subscription-variant" id="subscription-variant-1" value="binding_period" :disabled="locked" v-model="subscription.type">
                              <label class="form-check-label" for="subscription-variant-1">
                                Fast abonnemangsperiod
                              </label>
                            </div>
                            <div class="form-option-section-content" :class="{ show: subscription.type === 'binding_period'}">
                                <div class="row">
                                    <div class="col">
                                        <input-text
                                            type="number"
                                            name="num_months_binding"
                                            label="Längd"
                                            :disabled="locked"
                                            v-model="subscription.num_months_binding"
                                            addon="månader"
                                            form-group-class="mb-0"
                                            customErrorMessage="Ange längd"
                                        />
                                    </div>
                                    <div class="col">
                                        <input-text
                                            type="number"
                                            name="num_months_notice_period"
                                            label="Uppsägningstid"
                                            :disabled="locked"
                                            v-model="subscription.num_months_notice_period"
                                            addon="månader"
                                            form-group-class="mb-0"
                                            customErrorMessage="Ange uppsägningstid"
                                        />
                                    </div>
                                    <div class="col">
                                        <input-text
                                            type="number"
                                            name="num_treatments"
                                            label="Max antal behandlingar"
                                            :disabled="locked"
                                            v-model="subscription.num_treatments"
                                            addon="st"
                                            form-group-class="mb-0"
                                            customErrorMessage="Ange max antal behandlingar"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-option-section" :class="{ 'inactive' : subscription.type !== 'dynamic_period'}">
                            <div class="form-check mb-0">
                              <input class="form-check-input" type="radio" name="subscription-variant" id="subscription-variant-2" value="dynamic_period" :disabled="locked" v-model="subscription.type">
                              <label class="form-check-label" for="subscription-variant-2">
                                Löpande abonnemang med uppsägningstid
                              </label>
                            </div>
                            <div class="form-option-section-content" :class="{ show: subscription.type === 'dynamic_period'}">
                                <div class="row">
                                    <div class="col">
                                        <input-text
                                            type="number"
                                            name="num_months_settlement_interval"
                                            label="Avräkningsperiod"
                                            :disabled="locked"
                                            v-model="subscription.num_months_settlement_interval"
                                            addon="månader"
                                            form-group-class="mb-0"
                                            customErrorMessage="Ange avräkningsperiod"
                                        />
                                    </div>
                                    <div class="col">
                                        <input-text
                                            type="number"
                                            name="num_months_notice_period"
                                            label="Uppsägningstid"
                                            :disabled="locked"
                                            v-model="subscription.num_months_notice_period"
                                            addon="månader"
                                            form-group-class="mb-0"
                                            customErrorMessage="Ange uppsägningstid"
                                        />
                                    </div>
                                    <div class="col">
                                        <input-text
                                            type="number"
                                            name="num_treatments"
                                            label="Max antal behandlingar"
                                            :disabled="locked"
                                            v-model="subscription.num_treatments"
                                            addon="st"
                                            form-group-class="mb-0"
                                            customErrorMessage="Ange max antal behandlingar"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-option-section" :class="{ 'inactive' : subscription.type !== 'unlimited'}">
                            <div class="form-check mb-0">
                              <input class="form-check-input" type="radio" name="subscription-variant" id="subscription-variant-4" value="unlimited" :disabled="locked" v-model="subscription.type">
                              <label class="form-check-label" for="subscription-variant-4">
                                  Löpande abonnemang utan pott
                              </label>
                            </div>
                            <div class="form-option-section-content" :class="{ show: subscription.type === 'unlimited'}">
                                <div class="row">
                                    <div class="col-8">
                                        <input-text
                                            type="number"
                                            name="num_months_notice_period"
                                            label="Uppsägningstid"
                                            :disabled="locked"
                                            v-model="subscription.num_months_notice_period"
                                            addon="månader"
                                            form-group-class="mb-0"
                                            customErrorMessage="Ange uppsägningstid"
                                        />
                                    </div>
                                    <div class="col-8">
                                        <input-text
                                            type="number"
                                            name="num_employees"
                                            label="Max antal anställda"
                                            :disabled="locked"
                                            v-model="subscription.num_employees"
                                            addon="st"
                                            form-group-class="mb-0"
                                            customErrorMessage="Ange max antal anställda"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-option-section" :class="{ 'inactive' : subscription.type !== 'pay_per_treatment'}">
                            <div class="form-check mb-0">
                              <input class="form-check-input" type="radio" name="subscription-variant" id="subscription-variant-3" value="pay_per_treatment" :disabled="locked" v-model="subscription.type">
                              <label class="form-check-label" for="subscription-variant-3">
                                Betala per behandling
                              </label>
                            </div>
                            <div class="form-option-section-content" :class="{ show: subscription.type === 'pay_per_treatment'}">
                                <div class="row">
                                    <div class="col-8">
                                        <input-text
                                            type="number"
                                            name="num_months_notice_period"
                                            label="Uppsägningstid"
                                            :disabled="locked"
                                            v-model="subscription.num_months_notice_period"
                                            addon="månader"
                                            form-group-class="mb-0"
                                            customErrorMessage="Ange uppsägningstid"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

            </div>

        <div class="d-flex justify-content-end">
            <button class="btn btn-primary" :disabled="patcher.submitted" @click="patcherPatch()">
                <span class="spinner-border spinner-border-sm"></span>
            Spara
        </button>
        </div>

    </div>

</template>

<script>

import patcher from '../../../../shared/mixins/patcher'
import fetcher from '../../../../shared/mixins/fetcher'

export default {

    mixins: [
        patcher,
        fetcher
    ],

    props: {
        subscription_id: {
            required: true
        }
    },

    data () {
        return {
            subscription: null,
            pricePeriods: [],
            fetcher: {
                autoFill: [
                    'subscription',
                    'pricePeriods'
                ]
            }
        }
    },

    computed: {
        fetcherUrl () {
            return '/subscriptions/' + this.subscription_id + '/tabSettings'
        },
        patcherUrl () {
            return '/subscriptions/' + this.subscription.id
        },
        patcherData () {
            return this.subscription
        },
        locked () {
            return this.pricePeriods.length > 0
        },
        disable40minutes () {
            return this.subscription.external === true || this.subscription.type === 'unlimited'
        },
        disable50minutes () {
            return this.subscription.type === 'unlimited'
        }
    },

    watch: {
        subscription: {
            deep: true,
            handler () {
                if (this.subscription.type === 'binding_period') {
                    this.subscription.num_months_settlement_interval = null
                    this.subscription.num_employees = null
                }
                if (this.subscription.type === 'dynamic_period') {
                    this.subscription.num_months_binding = null
                    this.subscription.num_employees = null
                }
                if (this.subscription.type === 'pay_per_treatment') {
                    this.subscription.num_months_binding = null
                    this.subscription.num_months_settlement_interval = null
                    this.subscription.num_treatments = null
                    this.subscription.num_employees = null
                }

                if (this.subscription.type === 'unlimited') {
                    this.subscription.external = false
                    this.subscription.num_months_binding = null
                    this.subscription.num_months_settlement_interval = null
                    this.subscription.num_treatments = null
                }

                if (this.subscription.duration_id === 2 && this.disable40minutes) {
                    this.subscription.duration_id = null
                }

                if (this.subscription.duration_id === 4 && this.disable50minutes) {
                    this.subscription.duration_id = null
                }
            }
        }
    },

    methods: {
        patcherSuccess () {
            bus.$emit(
                'notify',
                'Inställningarna har sparats'
            )
        }
    }

}
</script>
